import { defineStore, acceptHMRUpdate } from "pinia";
import { createTranslationHighlightField } from "../lib/createTranslationHighlightField";

export const useTranslationImportantInformation = defineStore(
  "translation-content-important-information-field",
  createTranslationHighlightField({
    fieldId: "important_information",
    isRequired: false,
    highlightKey: "important_information",
    customKey: "custom_important_information",
    premadeKey: "premade_important_information",
  })
);

// HMR
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useTranslationImportantInformation, import.meta.hot));
}
